module.exports = __webpack_public_path__ + "media/buttons/sign-in-6488fb5d.png";